export default __webpack_public_path__ + "icon_close.4b69d61e188eabc997f45754b5abbb5b.svg";